import { useEffect } from 'react';

const GoogleAnalytics = () => {
  useEffect(() => {
    // Track initial page view
    if (window.gtag) {
      window.gtag('config', 'G-CXCMEGDLKP', {
        page_path: window.location.pathname + window.location.search,
        page_title: document.title
      });
    }
  }, []);

  return null; // This component doesn't render anything
};

export default GoogleAnalytics; 